/** Shared dark-view form styling for the Portal admin surfaces. */
export const FIELD =
  'mt-3 w-full border-0 border-b border-paper/25 bg-transparent pb-2 font-sans text-sm tracking-wide2 text-paper placeholder:text-paper/30 focus:border-paper focus:outline-none'

export const SELECT = `${FIELD} appearance-none`

export const OPTION = 'bg-ink text-paper'

export const BUTTON_SOLID =
  'label border border-paper bg-paper px-6 py-3.5 text-ink transition-colors duration-150 ease-out hover:bg-paperDeep'

export const BUTTON_GHOST =
  'label border border-paper/40 px-6 py-3.5 text-paper transition-colors duration-150 ease-out hover:border-paper'

export const BUTTON_QUIET =
  'label text-paper/40 transition-colors duration-150 ease-out hover:text-paper'
